import React from 'react'
import { faChartPieAlt } from '@fortawesome/pro-regular-svg-icons/faChartPieAlt'
import { faChartPieAlt as faChartPieSolidAlt } from '@fortawesome/pro-solid-svg-icons/faChartPieAlt'
import { reverse } from 'src/routes/config'
import MainMenuItem from 'src/components/Menu/MainMenuItem'
import isFeatureEnabled, { FEATURES } from 'src/utils/isFeatureEnabled'
import useTranslations from 'src/hooks/useTranslations'
import getEnvVariableValue, { VARIABLES } from 'src/utils/getEnvVariableValue'

const baseUrlHorizon = getEnvVariableValue(VARIABLES.OLD_HORIZON_BASE_URL)

export default function CostControlMenu({ parentIsCollapsed }) {
    const { t } = useTranslations('MainMenu', 'MainMenu')
    return (
        <MainMenuItem
            icon={faChartPieAlt}
            iconActive={faChartPieSolidAlt}
            title={t('Cost control')}
            to={
                isFeatureEnabled(FEATURES.COST_CONTROL_MENU_OPTION)
                    ? reverse('cost-control')
                    : {
                          pathname: `${baseUrlHorizon}/cost-control`,
                      }
            }
            externalLink={!isFeatureEnabled(FEATURES.COST_CONTROL_MENU_OPTION)}
            parentIsCollapsed={parentIsCollapsed}
        />
    )
}
